export const PROVIDER_FORM_INPUT_CLASS =
  "w-full rounded-lg border border-gray-200 bg-white px-3 py-2.5 text-sm text-gray-800 outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100";

export const ADD_PROVIDER_GRID_STYLE = {
  display: "grid",
  gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
  gap: "16px",
  width: "100%",
  alignItems: "start",
};

export const ADD_PROVIDER_CONTACT_GRID_STYLE = {
  display: "grid",
  gridTemplateColumns: "repeat(5, minmax(0, 1fr))",
  gap: "16px",
  width: "100%",
  alignItems: "start",
};

export function getProviderFormLayout(embedded = false) {
  if (!embedded) {
    return {
      wrap: "cms-provider-form-page",
      inner: "cms-provider-add-card",
      form: "cms-provider-add-form",
      section: "cms-provider-add-section",
      sectionTitle: "cms-provider-add-section-title",
      gridClass: "cms-provider-add-grid",
      gridStyle: ADD_PROVIDER_GRID_STYLE,
      contactGridClass: "cms-provider-add-grid cms-provider-add-grid--5",
      contactGridStyle: ADD_PROVIDER_CONTACT_GRID_STYLE,
      field: "cms-provider-add-field",
      fieldFull: "cms-provider-add-field cms-provider-add-field--full",
      fieldSpan2: "cms-provider-add-field cms-provider-add-field--span-2",
      label: "cms-provider-add-label",
      requiredMark: "required",
      control: "cms-provider-add-control",
      controlMulti: "cms-provider-add-control cms-provider-add-control--multiselect",
      input: "cms-provider-add-input",
      select: "cms-provider-add-select",
      textarea: "cms-provider-add-textarea",
      error: "cms-provider-add-error",
      footer: "cms-provider-add-footer",
      cancelBtn: "cms-provider-add-btn-cancel",
      submitBtn: "cms-provider-add-submit-btn",
      contactBlock: "cms-provider-add-contact-block",
      contactActions: "cms-provider-add-contact-actions",
      btnOutlineDanger:
        "cms-provider-add-btn-outline cms-provider-add-btn-outline--danger",
      btnFill: "cms-provider-add-btn-fill",
      multiselect: "cms-provider-add-multiselect",
      notesSpaced: " cms-provider-add-notes-spaced",
      existingNote: "cms-provider-form-existing-note",
      noAccess: "cms-provider-add-no-access",
      backBtn: "cms-provider-page-back",
      cardHeader: "cms-provider-add-card-header",
      cardTitle: "cms-provider-add-card-title",
    };
  }

  return {
    wrap: "cms-provider-form-embedded w-full min-w-0",
    inner: "w-full",
    form: "flex w-full flex-col gap-6",
    section: "flex w-full flex-col gap-4",
    sectionTitle:
      "border-b border-gray-100 pb-2 text-xs font-bold uppercase tracking-wide text-gray-500",
    gridClass:
      "grid w-full grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4",
    gridStyle: null,
    contactGridClass:
      "grid w-full grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-5",
    contactGridStyle: null,
    field: "cms-provider-add-field flex min-w-0 flex-col gap-1.5",
    fieldFull: "cms-provider-add-field flex min-w-0 flex-col gap-1.5 lg:col-span-full",
    fieldSpan2: "cms-provider-add-field flex min-w-0 flex-col gap-1.5 sm:col-span-2 lg:col-span-2",
    label: "mb-1.5 block text-sm font-semibold text-gray-700",
    requiredMark: "text-red-500",
    control: "w-full min-w-0",
    controlMulti:
      "cms-provider-add-control cms-provider-add-control--multiselect relative z-[1] w-full min-w-0 [&_.multiSelectContainer]:w-full [&_.optionListContainer]:z-[200]",
    input: PROVIDER_FORM_INPUT_CLASS,
    select: PROVIDER_FORM_INPUT_CLASS,
    textarea:
      "min-h-[88px] w-full resize-y rounded-lg border border-gray-200 bg-white px-3 py-2.5 text-sm text-gray-800 outline-none transition focus:border-blue-500 focus:ring-2 focus:ring-blue-100",
    error: "text-xs text-red-600",
    footer:
      "flex flex-wrap items-center justify-end gap-3 border-t border-gray-100 pt-4 mt-2",
    cancelBtn:
      "rounded-lg border border-gray-200 bg-white px-4 py-2 text-sm font-semibold text-gray-600 transition hover:bg-gray-50",
    submitBtn:
      "rounded-lg border-0 bg-[#0B2166] px-4 py-2 text-sm font-semibold text-white transition hover:opacity-90",
    contactBlock: "rounded-lg border border-gray-100 bg-slate-50 p-4",
    contactActions: "mt-3 flex flex-wrap items-center gap-2",
    btnOutlineDanger:
      "inline-flex h-8 shrink-0 items-center justify-center rounded-md border border-red-200 bg-white px-3 text-xs font-semibold text-red-600 transition hover:bg-red-50",
    btnFill:
      "inline-flex h-8 shrink-0 items-center justify-center rounded-md border-0 bg-blue-600 px-3 text-xs font-semibold text-white transition hover:bg-blue-700",
    multiselect: "cms-provider-add-multiselect w-full",
    notesSpaced: "",
    existingNote:
      "mt-2 rounded-md border border-gray-100 bg-gray-50 p-3 text-xs text-gray-600",
    noAccess:
      "rounded-lg border border-gray-200 bg-white p-6 text-center text-sm text-gray-500",
    backBtn: "cms-provider-page-back",
    cardHeader: "cms-provider-add-card-header",
    cardTitle: "cms-provider-add-card-title",
  };
}
